import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  BoundaryTerritoryEditSubmitModalContainer, type BoundaryTerritoryEditSubmitModalContainerProps,
} from './boundaryTerritoryEditSubmitModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    BoundaryTerritoryEditSubmit: BoundaryTerritoryEditSubmitModalContainerProps;
  }
}
modalRenderer.register('BoundaryTerritoryEditSubmit', BoundaryTerritoryEditSubmitModalContainer);
